import "./registerServiceWorker";
import "./assets/pwa.css";
import "./assets/storefront.css";
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import axios from "axios";
import VueFeather from 'vue-feather';
import PrimeVue from 'primevue/config'
import Aura from '@primevue/themes/aura'
import 'primeicons/primeicons.css'
import Tree from 'primevue/tree'
import 'nouislider/dist/nouislider.css'

import { i18n } from './i18n/index.js'
import { createPinia } from 'pinia'
import persisted from 'pinia-plugin-persistedstate'
import { useSettingsStore } from '@/stores/settings'
import { useAuthStore } from '@/stores/auth'
import '@/assets/fonts.css'

// Session-cookie auth: gdy frontend jest na innym porcie niż backend (np. 8080 vs 9898)
// przeglądarka wymaga credentials, aby zapisać i wysyłać JSESSIONID.
axios.defaults.withCredentials = true;
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';

async function bootstrap() {
  const app = createApp(App)

  const pinia = createPinia()
  pinia.use(persisted)
  app.use(pinia)

  axios.interceptors.response.use(
    response => response,
    error => {
      if (error?.response?.status === 423 && error?.response?.data?.code === 'ADMIN_PIN_REQUIRED') {
        const auth = useAuthStore(pinia)
        auth.adminPinRequired = true
        auth.adminPinUnlocked = false
        const current = router.currentRoute.value
        if (current.path !== '/admin-unlock') {
          router.replace({ path: '/admin-unlock', query: { redirect: current.fullPath } }).catch(() => {})
        }
      }
      return Promise.reject(error)
    }
  )

  app.use(i18n)

  app.use(router)
  app.use(PrimeVue, { theme: { preset: Aura } })
  app.component(VueFeather.name, VueFeather)
  app.component('Tree', Tree)

  const settings = useSettingsStore()
  await settings.init(navigator.language)

  app.mount('#app')
}
bootstrap()
